import { create } from "zustand";

const useBootstrapStore = create((set) => ({
  bootstrapData: null,
  permissions: [],
  defaultWarehouse: null,

  setBootstrapData: (data) => {
    set({
      bootstrapData: data,
      permissions: data?.permissions || [],
      defaultWarehouse: data?.default_warehouse || null,
    });
  },
  clearBootstrap: () =>
    set({
      bootstrapData: null,
      permissions: [],
      defaultWarehouse: null,
    }),
}));

export default useBootstrapStore;
